import { array, boolean, defineAction, enumerated, number, object, string } from '~/prix'
import insightTopInsightsByRelevanceReadAction from './insightTopInsightsByRelevanceRead.action.json'

const insightTopInsightsByRelevanceReadDefinition = defineAction({
  ...insightTopInsightsByRelevanceReadAction,
  input: object({
    limit: number().isOptional(),
    offset: number().isOptional(),
  }),
  output: object({
    source: enumerated({
      user: 'user',
      global: 'global',
    }),
    limit: number(),
    offset: number(),
    isMonitorUser: boolean(),
    items: array(
      object({
        id: string(),
        title: string(),
        description: string(),
        relevance: number(),
        updatedAt: string(),
        variableLabel: string().isOptional(),
        variableTitle: string().isOptional(),
        alertPreset: string().isOptional(),
        alertName: string().isOptional(),
        alertColor: string().isOptional(),
        delimitationTitle: string().isOptional(),
        productName: string().isOptional(),
        portfolioName: string().isOptional(),
      }),
    ),
  }),
  cache: () => ({
    front: {
      expirationMsForFallback: 1000 * 60 * 2,
      expirationMsForUpdate: 1000 * 60,
    },
  }),
})

export default insightTopInsightsByRelevanceReadDefinition
